module.exports = __webpack_public_path__ + "mobile/img/img_showpopup.6ecc46c4.png";